import React from 'react'
import AdmAttendanceEntry from '../../components/AdminTabs/AdminAttendanceEntry/AdmAttendanceEntry'

const AttendanceEntry = () => {
  return (
    <div>
        <AdmAttendanceEntry />
    </div>
  )
}

export default AttendanceEntry